import apiClient from '../apiClient';
import { GET_CITY_GROUP_LIST_URL } from '../apiUrl';

const getCityGroupListApi = () => {
  return apiClient.get(GET_CITY_GROUP_LIST_URL);
};

export default getCityGroupListApi;
